"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var FeatureFlag_1 = __importDefault(require("@CommonFrontendBackend/FeatureFlag"));
exports.default = (function (integrationName) {
    switch (integrationName) {
        case "mixPanel":
        case "kissMetrics":
        case "googleAnalytics":
        case "heapAnalytics":
            return "analyticsIntegrations";
        case "slack":
            return "slack integration";
        case "olark":
        case "slaask":
        case "crisp":
        case "drift":
            return FeatureFlag_1.default.LiveChatIntegrations;
        case "xero":
        case "freshbooks":
        case "quickbooks":
            return "accounting integrations";
        case "sfdc":
            return "salesforce";
        case "hubspot":
        case "pipedrive":
            return "crm-integrations";
        case "hotjar":
        case "fullStory":
        case "crazyEgg":
            return "interactionRecordingIntegrations";
        case "stripe":
            return "payment integrations";
        case "intercom":
            return FeatureFlag_1.default.LiveChatIntegrations;
        case "zapier":
        case "asana":
        case "airtable":
        case "zoho":
        case "podio":
        case "eventbrite":
        case "typeform":
        case "dasheroo":
            return "zapier integration";
    }
});
